import React from 'react'

const BlogPage = () => {
  return (
    <div>
      Blog page
    </div>
  )
}

export default BlogPage
